import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import {
  AppToolbarOptionsComponent,
  AppButtonComponent,
} from '@ifaa-components/ui-components';
import { TranslatePipe } from '@ngx-translate/core';
import { AppComponentWrapperComponent } from 'src/app/modules/shared/components/app-component-wrapper/app-component-wrapper.component';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { MessagePipe } from 'src/app/modules/shared/pipes/message';
import { TextTransformPipe } from 'src/app/modules/shared/pipes/textTransform';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-calculator-view',
  templateUrl: './calculator-view.component.html',
  styleUrls: ['./calculator-view.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    AppComponentWrapperComponent,
    AppToolbarOptionsComponent,
    TextTransformPipe,
    MessagePipe,
    AsyncPipe,
    AppButtonComponent,
    MatIcon,
    AnimateCssDirective,
    NgIf,
  ],
})
export class CalculatorViewComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  superannuationCalculator =
    environment.views.calculator.superannuationCalculator;
  superContributionOptimiser =
    environment.views.calculator.superContributionOptimiser;
  retirementProjectionCalculator =
    environment.views.calculator.retirementProjectionCalculator;

  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  openUrl(url: string) {
    window.open(url, '_blank').focus();
  }
}
